<template>
	<div
		class="--axis --axis-y"
		:style="{ height: `${containerHeight}px` }"
	>
		<span
			v-for="item in items"
			:key="item.value"
			class="--axis-y-item"
			:style="{ top: `${item.positionY}px` }"
		>
			{{ item.label }}
		</span>
	</div>
</template>

<script>
const itemHeight = 10
const minItemInterval = 30

/**
 * @typedef {Object} AxisItem
 * @property {number} value
 * @property {string} label
 * @property {number} positionY
 */

export default {
	name: 'AxisY',
	props: {
		height: {
			type: Number,
			default: 256
		},
		min: {
			type: Number,
			default: 0
		},
		max: {
			type: Number,
			default: 24000
		}
	},
	computed: {
		containerHeight () {
			return this.height + itemHeight
		},
		/**
		 * @returns {AxisItem[]}
		 */
		items () {
			const items = []
			const divs = Math.floor(this.height / minItemInterval)
			const span = (this.max - this.min) / divs
			for (let i = 0; i <= divs; i++) {
				const value = this.min + span * i
				const positionY = Math.round(this.height * (1 - i / divs))
				items.push({
					value,
					label: this.format(value),
					positionY
				})
			}
			return items
		}
	},
	methods: {
		/**
		 * 数値をラベル表示値に変換する
		 * @param {number} number
		 * @returns {string}
		 */
		format (number) {
			if (number >= 100000) {
				return Math.round(number / 1000) + ' k'
			}
			if (number >= 1000) {
				return (number / 1000).toFixed(1) + ' k'
			}
			return String(Math.round(number))
		}
	}
}
</script>

<style lang="scss" scoped>
.--axis-y {
	position: relative;
}

.--axis-y-item {
	position: absolute;
	display: block;
	left: 0;
	right: 0;
	padding-right: 6px;
	font-size: 10px;
	line-height: 1;
	text-align: right;

	&::after {
		content: "";
		display: block;
		position: absolute;
		right: 0;
		top: 5px;
		width: 3px;
		height: 1px;
		background: #777;
	}
}
</style>
